module.exports = __webpack_public_path__ + "static/media/visa.b8936340.png";